import React from "react";
import {AppBar, createStyles, Theme, Toolbar, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        borderBottom:{
                borderBottom :" 1px solid #F1EFE9"
        },
        backgroundColor:{
            backgroundColor:"#FFFFFF",    
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        image:{
            maxHeight:"23.87px",
            maxWidth:"180px",
            [theme.breakpoints.down('sm')]: {
                maxWidth: "160px",
              },
        }
    }),
);

interface MenuBarPropsInterface{
    title:string;
}

const MenuBar: React.FunctionComponent<MenuBarPropsInterface> = (props) => {
    const classes = useStyles();

    return (
    <>
        <AppBar position="fixed" elevation={0} className={classes.borderBottom}>
            <Toolbar className={classes.backgroundColor}>
                <img className={classes.image} src={"/images/SS_PeachPayments_Logo_Horizontal_Icon.svg"} alt="Peach Payments"/>
                <Typography className={"headerTitle"}>
                    {props.title}
                </Typography>
            </Toolbar>
        </AppBar>
        <Toolbar />
      </>)
};

export default MenuBar;